import * as React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
};

export const InsuraBotIcon = React.forwardRef<SVGSVGElement, Props>(
  ({ size = 24, className, ...rest }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 500 410"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M386.363 22.731H113.636C88.5321 22.731 68.1814 43.0816 68.1814 68.1855V250.004C68.1814 275.108 88.5321 295.458 113.636 295.458H386.363C411.467 295.458 431.818 275.108 431.818 250.004V68.1855C431.818 43.0816 411.467 22.731 386.363 22.731Z"
        stroke="currentColor"
        strokeWidth="45.4545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7263 386.371H477.272"
        stroke="currentColor"
        strokeWidth="45.4545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M204.546 113.636V159.091"
        stroke="currentColor"
        strokeWidth="45.4545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M295.454 113.636V159.091"
        stroke="currentColor"
        strokeWidth="45.4545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
);

InsuraBotIcon.displayName = "InsuraBotIcon";
